import { Component, Input, OnInit, ViewChild, OnChanges, inject } from '@angular/core';
import { FilterListComponent } from 'gung-list';
import { AssortmentTreeListConfigService } from '../../services/assortment-tree-list-config/assortment-tree-list-config.service';
import { Assortment, AssortmentRecursive, AssortmentService } from './../../services/assortment.service';
import { ProductListV2ConfigService } from '../../services/product-list-v2-config/product-list-v2-config.service';
import { Router } from '@angular/router';
import {
  BaseViewConfigService,
  CurrentAssortmentService
} from '../../services/base-view-config/base-view-config.service';
import { catchError, first, of } from 'rxjs';

@Component({
  selector: 'lib-assortment-tree-list',
  templateUrl: './assortment-tree-list.component.html',
  styleUrls: ['./assortment-tree-list.component.css'],
  standalone: false
})
export class AssortmentTreeListComponent implements OnInit, OnChanges {
  public configService = inject(AssortmentTreeListConfigService);
  public productListConfigService = inject(ProductListV2ConfigService);
  protected router = inject(Router);
  public currentAssortmentService? = inject(CurrentAssortmentService);
  protected assortmentService? = inject(AssortmentService);
  protected baseViewConfig = inject(BaseViewConfigService);

  @Input()
  private assortmentChildren: AssortmentRecursive[];

  @ViewChild('assortmentList') assortmentList: FilterListComponent<AssortmentRecursive>;

  currentAssortment: string;
  currentAssortmentObj: Assortment;
  showProductList = false;

  ngOnInit() {
    this.configService.assortmentObjectsSubject.next(this.assortmentChildren);
    if (this.baseViewConfig.showProductListInArticlesView()) {
      this.showProductList = true;
      if (this.router.url.includes('/')) {
        const currentAssortment = this.router.url.split('/').pop();
        if (currentAssortment !== 'articles') {
          this.currentAssortment = currentAssortment;
          this.currentAssortmentService.currentAssortment = { id: currentAssortment, extra: {} } as any;
          this.productListConfigService.assortmentSubject.next({ id: currentAssortment, extra: {} } as any);
          this.assortmentService
            .getAssortment(currentAssortment)
            .pipe(
              first(),
              catchError(err => {
                console.error(err);
                return of(null);
              })
            )
            .subscribe(assortment => {
              if (assortment) {
                this.currentAssortmentObj = assortment;
                this.currentAssortmentService.currentAssortment = this.currentAssortmentObj;
                this.productListConfigService.assortmentSubject.next(this.currentAssortmentObj);
              }
            });
          return;
        }
      }
      this.currentAssortmentObj = undefined;
      this.currentAssortment = undefined;
      this.productListConfigService.assortmentSubject.next(undefined);
      this.currentAssortmentService.currentAssortment = undefined;
    }
  }

  ngOnChanges() {
    this.configService.assortmentObjectsSubject.next(this.assortmentChildren);
  }
}
